import './style.css'
import * as THREE from 'three'
import { GUI } from 'dat.gui'
import { MeshLine, MeshLineMaterial, MeshLineRaycast } from 'three.meshline';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass';
import sources from './sources'

/**
 * Base
 */
// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene1 = new THREE.Scene()
const scene = new THREE.Scene()

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth / 2.5,
    height: window.innerWidth / 2.5
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth / 2.5
    sizes.height = window.innerWidth / 2.5

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

    bloomComposer.setSize(sizes.width, sizes.height)
})

/**
 * Ambient Light
 */
const light = new THREE.AmbientLight( 0x404040 ); // soft white light
scene.add( light );
 

/**
 * Directional Light
 */
const directionalLight = new THREE.DirectionalLight( 0xffffff, 1 );
directionalLight.position.set(1, 1, 1)
scene.add( directionalLight );
 

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.layers.enable(1)
camera.position.x = 0
camera.position.y = 0
camera.position.z = 5
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true


/**
 * Triangle
 */
const pointsT = []
pointsT.push(new THREE.Vector3(0, 0.5, 0));
pointsT.push(new THREE.Vector3(-0.5, -0.5, 0));
pointsT.push(new THREE.Vector3(0.5, -0.5, 0));
pointsT.push(new THREE.Vector3(0, 0.5, 0));
const lineT = new MeshLine();
lineT.setPoints(pointsT);
let materialT = new MeshLineMaterial({
    lineWidth: 0.1
});
materialT.onBeforeCompile = (shader) => {
    console.log(shader.vertexShader)
}
const triangle = new THREE.Mesh(lineT, materialT);
triangle.position.set(-1.5, 0, 0)


/**
 * Circle
 */
const pointsC = []
let r = 0.5;
for (let i = 0; i <= 360; i++) {
    let x = r * Math.cos(i * Math.PI / 180);
    let y = r * Math.sin(i * Math.PI / 180);
    pointsC.push(x, y, 0);
}
const lineC = new MeshLine();
lineC.setPoints(pointsC);
const materialC = new MeshLineMaterial({
    lineWidth: 0.05
});
const circle = new THREE.Mesh(lineC, materialC);
circle.position.set(0, 0, 0)


/**
 * Square
 */
const pointsS = []
let sqLength = 0.5
pointsS.push(new THREE.Vector3(-sqLength, sqLength, 0))
pointsS.push(new THREE.Vector3(sqLength, sqLength, 0))
pointsS.push(new THREE.Vector3(sqLength, sqLength, 0))
pointsS.push(new THREE.Vector3(sqLength, -sqLength, 0))
pointsS.push(new THREE.Vector3(-sqLength, -sqLength, 0))
pointsS.push(new THREE.Vector3(-sqLength, sqLength, 0))
const lineS = new MeshLine();
lineS.setPoints(pointsS);
const materialS = new MeshLineMaterial({
    lineWidth: 0.05
});
const square = new THREE.Mesh(lineS, materialS);
square.position.set(1.5, 0, 0)
// square.layers.set(1);

let group = new THREE.Group()
group.add(triangle)
group.add(square)
group.add(circle)
scene.add(group)

const fontLoader = new THREE.FontLoader();
let fonts = []
for (const source of sources) {
    if (source.type === 'font') {
        fontLoader.load(source.path, (font) => {
            fonts.push(font)
            fontLoaded()
        })
    }
}
let loaded = 0;
const toLoad = sources.length
let confText = [
    {
        size: 1,
        posX: -3.5,
        posY: 2,
        posZ: 0,
        rotX: 0,
        rotY: 0,
        rotZ: 0,
        color: new THREE.Color("#000000")
    },
    {
        size: 0.2,
        posX: -3.5,
        posY: -3,
        posZ: 0,
        rotX: 0,
        rotY: 0,
        rotZ: 0,
        color: new THREE.Color("#000000")
    },
    {
        size: 0.2,
        posX: -3.5,
        posY: -2.5,
        posZ: 0,
        rotX: 0,
        rotY: 0,
        rotZ: 0,
        color: new THREE.Color("#000000")
    },
]
let geometryTitle, title;
let geometryDate, date;
let geometryName, name;
const fontLoaded = () => {
    loaded++;
    if (loaded === toLoad) {
        /**
         * TEXT
         */

        // title
        geometryTitle = new THREE.TextGeometry("Title", {
            font: fonts[0],
            size: confText[0].size,
            height: 0.01,
        });
        title = new THREE.Mesh(geometryTitle, new THREE.MeshPhongMaterial({color: confText[0].color}));
        title.position.set(confText[0].posX, confText[0].posY, confText[0].posZ)
        scene.add(title)

        // date
        geometryDate = new THREE.TextGeometry("Date", {
            font: fonts[0],
            size: confText[1].size,
            height: 0.01,
        });
        date = new THREE.Mesh(geometryDate, new THREE.MeshPhongMaterial({color: confText[1].color}));
        date.position.set(confText[1].posX, confText[1].posY, confText[1].posZ)
        scene.add(date)

        // name
        geometryName = new THREE.TextGeometry("Name", {
            font: fonts[0],
            size: confText[2].size,
            height: 0.01,
        });
        name = new THREE.Mesh(geometryName, new THREE.MeshPhongMaterial({color: confText[2].color}));
        name.position.set(confText[2].posX, confText[2].posY, confText[2].posZ)
        scene.add(name)
    }
}




/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true,
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

const renderScene = new RenderPass(scene, camera);
const bloomPass = new UnrealBloomPass(
    new THREE.Vector2(sizes.width, sizes.height),
    1.5,
    0.4,
    0.85
)
bloomPass.threshold = 0
bloomPass.strength = 0.0
bloomPass.radius = 0

const bloomComposer = new EffectComposer(renderer)
bloomComposer.setSize(sizes.width, sizes.height)
bloomComposer.renderToScreen = true
bloomComposer.addPass(renderScene)
bloomComposer.addPass(bloomPass)

/**
 * Animate
 */
const clock = new THREE.Clock()
let lastElapsedTime = 0
let rotateElements = false
let rotateGroup = false

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - lastElapsedTime
    lastElapsedTime = elapsedTime

    // Update controls
    controls.update()

    // Update Shapes
    triangle.geometry.attributes.position.needsUpdate = true;
    triangle.needsUpdate = true;
    square.geometry.attributes.position.needsUpdate = true;
    square.needsUpdate = true;
    circle.geometry.attributes.position.needsUpdate = true;
    circle.needsUpdate = true;

    if (title) title.geometry.attributes.position.needsUpdate = true

    if (rotateElements) {
        triangle.rotation.y += 0.01
        circle.rotation.y += 0.01
        square.rotation.y += 0.01
    }
    if (rotateGroup) {
        group.rotation.y += 0.005
    }

    bloomComposer.render();
    // renderer.clearDepth();
    // camera.layers.set(0);
    // renderer.render(scene, camera);

    // bloomComposer.render();

    // Render
    // renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()

const loader = new THREE.TextureLoader();
loader.load("./textures/forest.jpeg", (event) => {
    scene.background = event;
})


/**
 * ==================================================================
 * =============================== UI ===============================
 * ==================================================================
 */

/**
 * Upload Image
 */
document.getElementById("upload-image").addEventListener("change", (event) => {
    loader.load(URL.createObjectURL(event.target.files[0]), (bg) => {
        scene.background = bg;
    })
})

/**
 * Rotation Elements
 */
document.getElementById("rotation-elements").addEventListener("change", (event) => {
    if (document.getElementById("rotation-elements").checked) {
        rotateElements = true
    } else {
        rotateElements = false
    }
})

/**
 * Rotation Group
 */
document.getElementById("rotation-group").addEventListener("change", (event) => {
    if (document.getElementById("rotation-group").checked) {
        rotateGroup = true
    } else {
        rotateGroup = false
    }
})

/**
 * Color Elements
 */
document.getElementById("color").addEventListener("input", (event) => {
    triangle.material.color = new THREE.Color(event.target.value);
    circle.material.color = new THREE.Color(event.target.value);
    square.material.color = new THREE.Color(event.target.value);
})

/**
 * Size Elements
 */
document.getElementById("elements-size").addEventListener("input", (event) => {
    group.scale.set(event.target.value, event.target.value, event.target.value)
})

/**
 * Bloom
 */
document.getElementById("bloom-strength").addEventListener("input", (event) => {
    bloomPass.strength = event.target.value
})
document.getElementById("bloom-threshold").addEventListener("input", (event) => {
    bloomPass.threshold = event.target.value
})
document.getElementById("bloom-radius").addEventListener("input", (event) => {
    bloomPass.radius = event.target.value
})

/**
 * TEXT - Title
 */
document.getElementById("title").addEventListener("input", (event) => {
    scene.remove(title)
    geometryTitle = new THREE.TextGeometry(event.target.value, {
        font: fonts[0],
        size: confText[0].size,
        height: 0.01,
    });
    title = new THREE.Mesh(geometryTitle, new THREE.MeshPhongMaterial({color: 0x000000}),);
    title.position.set(confText[0].posX, confText[0].posY, confText[0].posZ)
    scene.add(title)
})
document.getElementById("title-position-x").addEventListener("input", (event) => {
    confText[0].posX = event.target.value;
    title.position.x = confText[0].posX;
})
document.getElementById("title-position-y").addEventListener("input", (event) => {
    confText[0].posY = event.target.value;
    title.position.y = confText[0].posY;
})
document.getElementById("title-position-z").addEventListener("input", (event) => {
    confText[0].posZ = event.target.value;
    title.position.z = confText[0].posZ;
})
document.getElementById("title-rotation-x").addEventListener("input", (event) => {
    confText[0].rotX = event.target.value;
    title.rotation.x = confText[0].rotX;
})
document.getElementById("title-rotation-y").addEventListener("input", (event) => {
    confText[0].rotY = event.target.value;
    title.rotation.y = confText[0].rotY;
})
document.getElementById("title-rotation-z").addEventListener("input", (event) => {
    confText[0].rotZ = event.target.value;
    title.rotation.z = confText[0].rotZ;
})
document.getElementById("title-size").addEventListener("input", (event) => {
    confText[0].size = event.target.value;
    title.scale.set(confText[0].size, confText[0].size, confText[0].size)
})
document.getElementById("title-color").addEventListener("input", (event) => {
    confText[0].color = new THREE.Color(event.target.value);
    title.material.color = confText[0].color;
})

/**
 * TEXT - Date
 */
 document.getElementById("date").addEventListener("input", (event) => {
    scene.remove(date)
    geometryDate = new THREE.TextGeometry(event.target.value, {
        font: fonts[0],
        size: 0.2,
        height: 0.01,
    });
    date = new THREE.Mesh(geometryDate, new THREE.MeshPhongMaterial({color: 0x000000}),);
    date.position.set(0, -3, 0)
    scene.add(date)
})
document.getElementById("date-position-x").addEventListener("input", (event) => {
    confText[1].posX = event.target.value;
    date.position.x = confText[1].posX;
})
document.getElementById("date-position-y").addEventListener("input", (event) => {
    confText[1].posY = event.target.value;
    date.position.y = confText[1].posY;
})
document.getElementById("date-position-z").addEventListener("input", (event) => {
    confText[1].posZ = event.target.value;
    date.position.z = confText[1].posZ;
})
document.getElementById("date-rotation-x").addEventListener("input", (event) => {
    confText[1].rotX = event.target.value;
    date.rotation.x = confText[1].rotX;
})
document.getElementById("date-rotation-y").addEventListener("input", (event) => {
    confText[1].rotY = event.target.value;
    date.rotation.y = confText[1].rotY;
})
document.getElementById("date-rotation-z").addEventListener("input", (event) => {
    confText[1].rotZ = event.target.value;
    date.rotation.z = confText[1].rotZ;
})
document.getElementById("date-size").addEventListener("input", (event) => {
    confText[1].size = event.target.value;
    date.scale.set(confText[1].size, confText[1].size, confText[1].size)
})
document.getElementById("date-color").addEventListener("input", (event) => {
    confText[1].color = new THREE.Color(event.target.value);
    date.material.color = confText[1].color;
})

/**
 * TEXT - Name
 */
 document.getElementById("name").addEventListener("input", (event) => {
    scene.remove(name)
    geometryName = new THREE.TextGeometry(event.target.value, {
        font: fonts[0],
        size: 0.2,
        height: 0.01,
    });
    name = new THREE.Mesh(geometryName, new THREE.MeshPhongMaterial({color: 0x000000}),);
    name.position.set(0, -3, 0)
    scene.add(name)
})
document.getElementById("name-position-x").addEventListener("input", (event) => {
    confText[2].posX = event.target.value;
    name.position.x = confText[2].posX;
})
document.getElementById("name-position-y").addEventListener("input", (event) => {
    confText[2].posY = event.target.value;
    name.position.y = confText[2].posY;
})
document.getElementById("name-position-z").addEventListener("input", (event) => {
    confText[2].posZ = event.target.value;
    name.position.z = confText[2].posZ;
})
document.getElementById("name-rotation-x").addEventListener("input", (event) => {
    confText[2].rotX = event.target.value;
    name.rotation.x = confText[2].rotX;
})
document.getElementById("name-rotation-y").addEventListener("input", (event) => {
    confText[2].rotY = event.target.value;
    name.rotation.y = confText[2].rotY;
})
document.getElementById("name-rotation-z").addEventListener("input", (event) => {
    confText[2].rotZ = event.target.value;
    name.rotation.z = confText[2].rotZ;
})
document.getElementById("name-size").addEventListener("input", (event) => {
    confText[2].size = event.target.value;
    name.scale.set(confText[2].size, confText[2].size, confText[2].size)
})
document.getElementById("name-color").addEventListener("input", (event) => {
    confText[2].color = new THREE.Color(event.target.value);
    name.material.color = confText[2].color;
})

/**
 * Download image
 */
document.getElementById("download").addEventListener("click", (event) => {
    var renderer3D;
    renderer3D = new THREE.WebGLRenderer({
        alpha: true,
        antialias: true,
        preserveDrawingBuffer: true
    });
    renderer3D.setSize(canvas.width, canvas.height);
    renderer3D.render(scene, camera);
    // download file like this.
    var a = document.createElement('a');
    a.href = renderer3D.domElement.toDataURL().replace("image/png", "image/octet-stream");
    a.download = 'academy.png'
    a.click();
})

/**
 * Arrow down
 */
const arrowDown = document.querySelectorAll('.arrow-down');
for (let i = 0; i < arrowDown.length; i++) {
    arrowDown[i].src = "./icons/arrow-down.svg"
}

/**
 * Open/Close Toolkit Container
 */
const toolkitElementTitle = document.querySelectorAll('.toolkit-element-title');
toolkitElementTitle.forEach(el => el.addEventListener('click', event => {
    event.currentTarget.classList.toggle("show");
    event.currentTarget.nextSibling.classList.toggle("show");
}));